import { TAvailableConfigValues } from '@customTypes/common';

export interface IThroughputEstimatorConfig {
  optimalResolutionLowerBound: number;
  optimalResolutionUpperBound: number;
  amountOfFragmentToBecomeConfident: number;
}

export const defaultThroughputEstimatorConfig: IThroughputEstimatorConfig = {
  optimalResolutionLowerBound: 0.65,
  optimalResolutionUpperBound: 0.88,
  amountOfFragmentToBecomeConfident: 10,
};

export const availableThroughputEstimatorValues: TAvailableConfigValues<IThroughputEstimatorConfig> = {};
